import { useStore } from '@/store/index'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'next-i18next'
import { HOME_PAGE_URL } from '@/constants/index'
import { formatTranslate, getPriceTdk, twitterSeo } from '@/utils/tools'
import { DefaultSeo } from 'next-seo'
import Head from 'next/head'
import { useRouter } from 'next/router'

const PriceTdk = () => {
  const { t } = useTranslation()

  const { t: fundingTrans } = useTranslation('fundraising')
  const { pageType, coinCount } = useStore().baseStore
  const router = useRouter()

  const PriceTdkObj = {
    title: t(formatTranslate(getPriceTdk(pageType)?.tdkTitle ?? '', {})),
    // 动态币种数量赋值变量
    description: t(formatTranslate(getPriceTdk(pageType)?.tdkDescription ?? '', {}), { quantity: coinCount }),
  }

  if (pageType === HOME_PAGE_URL.Fundraising) {
    PriceTdkObj.title = fundingTrans(formatTranslate(getPriceTdk(pageType)?.tdkTitle ?? '', {}))
    PriceTdkObj.description = fundingTrans(formatTranslate(getPriceTdk(pageType)?.tdkDescription ?? '', {}))
  }
  /**
   * @description: twitter 动态seo配置
   * @return {*}
   */
  const twitter = twitterSeo({ title: PriceTdkObj.title, description: PriceTdkObj.description })

  return (
    <>
      <Head>
        {/* twitter 社媒标签 */}
        {twitter.map(item => (
          <meta key={item.name} {...item} />
        ))}
      </Head>

      <DefaultSeo key={router?.asPath} title={PriceTdkObj.title} description={PriceTdkObj.description} />
    </>
  )
}

export default observer(PriceTdk)
